import { render, staticRenderFns } from "./TabelaDeItensDeItem.vue?vue&type=template&id=c5ef5a2c&scoped=true"
import script from "./TabelaDeItensDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeItensDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeItensDeItem.vue?vue&type=style&index=0&id=c5ef5a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ef5a2c",
  null
  
)

export default component.exports